import AccessibleIcon from './AccessibleIcon'

export default AccessibleIcon
